module.exports = __webpack_public_path__ + "img/solution13.a836f312.png";